module.exports = __webpack_public_path__ + "img/cap-diploma.cd47269b.gif";